import { Children } from 'react';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { TooltipWrapper } from '../TooltipWrapper/TooltipWrapper.es.js';

const Styles = labelStyles("AvatarGroup", {
  root: css`
    ${Typography.base};
    display: flex;
    align-items: center;
    user-select: none;
    width: max-content;

    &[data-size='40'] > * {
      margin-right: -10px;
    }
    &[data-size='25'] > * {
      margin-right: -5px;
    }
    &[data-size='18'] > * {
      margin-right: -3px;
    }
    &[data-size] > *:last-of-type {
      margin-right: 0;
    }
  `,
  count: css`
    --AvatarGroup__count-text-indent: 0px;
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
    color: ${Colors.neutral800};
    font-weight: 700;
    line-height: 1;

    [data-size='25'] & {
      font-size: 14px;
    }
    &::before {
      content: '+';
      text-indent: var(--AvatarGroup__count-text-indent);
    }

    [data-size='40'] & {
      --AvatarGroup__count-text-indent: -3px;
      background-color: ${Colors.neutral300};
      border: 1px solid #fff;
      border-radius: 100px;
      font-size: 16px;
      padding: 0 10px;
      height: 40px;
      min-width: 40px;
      border-width: 2px;
    }

    [data-size='25'] & {
      --AvatarGroup__count-text-indent: -2px;
      font-size: 14px;
      height: 25px;
      min-width: 25px;
      padding: 0 4px 0 11px;
    }

    [data-size='18'] & {
      --AvatarGroup__count-text-indent: -1px;
      font-size: 12px;
      height: 18px;
      min-width: 18px;
      padding: 0 4px 0 7px;
    }
  `
});
const AvatarGroup = ({ children, size = void 0, max = 3 }) => {
  const childrenArray = Children.toArray(children).filter(Boolean);
  const slicedChildren = childrenArray.slice(0, max);
  const remainingChildren = childrenArray.length - slicedChildren.length;
  const content = size !== 40 ? jsx(
    "div",
    { css: Styles.count, "data-zds": true },
    Math.min(remainingChildren, 999),
    " others"
  ) : jsx(TooltipWrapper, { content: `Plus ${remainingChildren} others`, position: "southeast" }, () => jsx("div", { "aria-label": `Plus ${remainingChildren} others`, css: Styles.count, "data-zds": true }, Math.min(remainingChildren, 999)));
  return jsx(
    "div",
    { css: Styles.root, "data-size": size, "data-zds": true },
    slicedChildren,
    remainingChildren > 0 && content
  );
};

export { AvatarGroup };
//# sourceMappingURL=AvatarGroup.es.js.map
